<template>
    <div class="behavior-report-preview" v-if="ratingItemsExists">

        <tool-output-page v-for="index in itemCollections.length"
                          :page-number="index"
                          :page-count="itemCollections.length">

            <behavior-report-feedback-report-header v-if="index == 1">
            </behavior-report-feedback-report-header>

            <behavior-report-feedback-rating-item-grid
                  v-for="item in itemCollections[index - 1]"
                  :item="item" :landscape="landscape">
            </behavior-report-feedback-rating-item-grid>

            <behavior-report-feedback-report-signature v-if="index == 1">
            </behavior-report-feedback-report-signature>

        </tool-output-page>

    </div>
</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'

    export default Vue.extend({
        name: "BehaviorReportPreview",
        mixins: [ToolMixin],
        props: {
            landscape: Boolean,
        },
        computed: {
            ratingItemsExists() {
              return this.docData.ratingItems !== undefined && this.docData.ratingItems !== null
            },
            linesPerPage() {
                if(this.landscape) {
                  return 12
                }
                if(this.docData.fontSize == "small") {
                  return 37
                } else {
                  return 30
                }
            },
            itemCollections() {
                var itemCollections = []
                var currentPageItems = []
                var currentPageLines = 0
                for(let i = 0; i < this.docData.ratingItems.length; i++) {
                    if(currentPageLines + this.linesForEntry(i) > this.linesPerPage && currentPageItems.length > 0) {
                        itemCollections.push(currentPageItems)
                        currentPageItems = []
                        currentPageLines = 0
                    }
                    currentPageItems.push(this.docData.ratingItems[i])
                    currentPageLines += this.linesForEntry(i)
                }
                if(currentPageItems.length > 0) {
                    itemCollections.push(currentPageItems)
                }
                return itemCollections
            },
        },
        methods: {
            linesForEntry(index) {
                let totalLength = 0
                // TODO(aidan): calc text lines based on length
                totalLength += 2
                // TODO: can this be more robust?
                switch(this.docData.ratingItems[index].responseFormat) {
                  case "1-3 / Poor to Good":
                    totalLength += 3
                    break
                  case "1-9 / Never to Always":
                    totalLength += 9
                    break
                  case "Accomplished / Not Accomplished":
                    totalLength += 2
                    break
                  case "Frequency Behavior Display":
                    totalLength += 5
                    break
                  case "Frowny to Smiley Face":
                    totalLength += 3
                    break
                  case "Percent Display Behavior":
                    totalLength += 6
                    break
                  case "Yes / No":
                    totalLength += 2
                    break
                }
                return totalLength
            },
        }
    })

</script>
